const faqs = [
    {
        id: 1,
        heading: 'How can I register?',
        content: 'Click on the “Register” button on our homepage or visit the Registration page. Fill out the form and follow the steps to confirm your spot.',
    },
    {
        id: 2,
        heading: 'What ticket types are available?',
        content: 'You can choose from General Admission, VIP Access, and Team Passes. Each includes unique features like premium seating, lounge access, or group discounts.',
    },
    {
        id: 3,
        heading: 'Is it possible to transfer my ticket?',
        content: 'Yes, tickets are transferable. Please contact our support team at least 3 days before the event to update attendee details.',
    },
    {
        id: 4,
        heading: 'Where can I find the full event schedule?',
        content: 'The complete agenda is listed on our “Event Schedule” page, including session times, speakers, and networking slots.',
    },
    {
        id: 5,
        heading: 'Are food and drinks included?',
        content: 'Yes, complimentary refreshments and lunch are included with most ticket types. VIP guests also enjoy access to a private lounge with exclusive catering.',
    },
];

export default faqs;